var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16.834 1.174 4.243 4.242M16.834 1.174 3.399 14.609M21.076 5.417 7.641 18.852M3.4 14.609l-.354 4.596 4.596-.353M14.006 4.002l4.242 4.243M4.106 13.902l4.243 4.243"
})));
SvgPencil.viewBox = '0 0 22 22';
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export default ForwardRef;